var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 163,
    viewBox: "0 0 144 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2820_24535)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 130,
    height: 135.2,
    rx: 11.2667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1409 82.0479V87.3582H27.4768V82.0479V76.729H22.1409V82.0479Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4768 50.178H22.1409V55.4883H27.4768V50.178Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.458 108.651H55.1221V113.961H60.458V108.651Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4768 60.7983V66.1086H22.1409V71.4189H27.4768V76.7292H32.8127H38.1573V82.048H43.4932V76.7292H48.8292V71.4189V66.1086H43.4932V71.4189H38.1573H32.8127V66.1086V60.7983V55.488H27.4768V60.7983Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1573 50.178H32.8127V55.4883H38.1573H43.4932V50.178H38.1573Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1735 92.8745H65.0354V87.5642H62.1735H59.303V92.8745H62.1735Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8289 55.488H43.4929V60.7983H48.8289V55.488Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1892 76.729H80.8533V82.0393H86.1892V76.729Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5251 18.3074H86.1892V23.6177H91.5251V18.3074Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.501 60.7983V55.488H64.8369V50.1777H59.501V44.8674H54.165V50.1777H48.8291V55.488H54.165V60.7983V66.1086V71.4188V76.7291H59.501V71.4188V66.1086H64.8369V60.7983H59.501Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1892 113.91H91.5251V108.6H86.1892H80.8533V113.91H86.1892Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8533 18.3074H75.5173V23.6177H80.8533V18.3074Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5171 60.7985V55.4883H74.1811V50.178H68.8452V55.4883V60.7985H63.5093V66.1088H68.8452H74.1811V60.7985H79.5171Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.636 50.178H104.301V55.4883H109.636V50.178Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3203 76.729H48.9844V82.0393H54.3203V76.729Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5171 44.8674V39.5571H80.8531V34.2382H86.189H91.525V28.928H86.189V23.6177H80.8531V28.928H75.5171V34.2382H70.1726V39.5571H64.8367V44.8674H70.1726H75.5171Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5171 82.0478V76.729H80.8531V71.4187H75.5171H70.1726V76.729H64.8367V82.0478H70.1726H75.5171Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5252 103.289V97.9699H86.1893H80.8533V92.6597H75.5174V97.9699H70.1728V103.289H64.8369H59.501V108.599H64.8369H70.1728H75.5174V103.289H80.8533V108.599H86.1893V103.289H91.5252Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1726 23.6177V18.3074H64.8367H59.5007V23.6177H54.1648V28.9279H59.5007H64.8367V23.6177H70.1726Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1726 28.928H64.8367V34.2382H70.1726V28.928Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5171 50.1779H78.1812V55.4882V60.7985V66.1088H83.5171H88.853V60.7985H83.5171V55.4882H88.853V50.1779H94.189V44.8676H88.853V39.5574H83.5171V44.8676V50.1779Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8369 34.238H59.501V39.5483H64.8369V34.238Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8533 87.3584V92.6686H86.1892H91.5251V87.3584H96.8611H102.197V82.0481H96.8611H91.5251H86.1892V87.3584H80.8533Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.636 66.1084H104.301V71.4187H109.636V66.1084Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5251 71.4187H86.1892V76.729H91.5251V71.4187Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.869 55.488H99.5335H94.189V60.7983H99.5335V66.1086H104.869V60.7983V55.488Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.197 71.4187H96.8611V76.729H102.197V71.4187Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4929 103.392H59.5093V82.0391H38.0535V87.3579H32.821V92.6682H38.0535V97.9785H32.821V103.289H38.0535V103.392H38.157V108.599H32.821V119.22H38.157V113.892H43.4929V103.392ZM55.3975 86.1226V99.4026H42.0533V86.1226H55.3975Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.869 82.0479H118.205V76.729H112.869H107.533H102.197V82.0479H107.533H112.869Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.869 60.7985H118.205V55.4883V50.178H112.869V55.4883V60.7985Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38 87.5642H65.0354V92.8745V98.1848H70.38V92.8745V87.5642Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.541 82.0481H118.205V87.3584H123.541V82.0481Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.549 71.4187V66.1084H118.205V71.4187V76.7289H123.549V71.4187Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4768 108.6H22.1409V113.91V119.22H27.4768V113.91V108.6Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.549 44.8675V18.2732H96.8264V44.8675H123.549ZM100.861 40.8783V22.2881H119.541V40.8783H100.861Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.541 26.2769H104.869V36.8974H115.541V26.2769Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.549 92.6685H96.8264V119.22H123.549V92.6685ZM100.861 115.239V96.649H119.541V115.239H100.861Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.541 100.63H104.869V111.25H115.541V100.63Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0806 18.3074V44.9017H48.743V18.3074H22.0806ZM44.7604 22.2879V40.8782H26.0803V22.2879H44.7604Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7519 26.2769H30.0801V36.8974H40.7519V26.2769Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4687 36.8205V17.9471C14.3474 16.2154 14.8826 14.5013 15.9687 13.143C16.6189 12.4286 17.4197 11.8659 18.3138 11.4951C19.2079 11.1244 20.1732 10.9547 21.1408 10.9983H41.0709C41.2286 10.9983 41.3799 10.9359 41.4914 10.8249C41.603 10.7139 41.6657 10.5634 41.6657 10.4064C41.6657 10.2494 41.603 10.0988 41.4914 9.98781C41.3799 9.8768 41.2286 9.81443 41.0709 9.81443H21.3822C19.7148 9.73111 18.0606 10.1464 16.6324 11.0069C15.606 11.6871 14.7627 12.6075 14.1766 13.6873C13.5905 14.7671 13.2794 15.9735 13.2705 17.2008C13.2188 20.3063 13.2705 23.4204 13.2705 26.5174V36.8119C13.2882 36.9577 13.3588 37.0921 13.4692 37.1895C13.5796 37.287 13.7221 37.3408 13.8697 37.3408C14.0172 37.3408 14.1597 37.287 14.2701 37.1895C14.3805 37.0921 14.4511 36.9577 14.4687 36.8119V36.8205Z",
    fill: "#1BC457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3468 128.193H20.3822C18.6427 128.31 16.9218 127.778 15.5549 126.701C14.8379 126.053 14.2732 125.256 13.9007 124.366C13.5283 123.477 13.3572 122.516 13.3998 121.553V101.694C13.3998 101.537 13.3372 101.386 13.2256 101.275C13.1141 101.164 12.9628 101.102 12.805 101.102C12.6473 101.102 12.496 101.164 12.3844 101.275C12.2729 101.386 12.2102 101.537 12.2102 101.694V121.313C12.1276 122.972 12.5448 124.618 13.4085 126.04C14.0919 127.061 15.0168 127.899 16.1021 128.481C17.1873 129.063 18.3996 129.371 19.6323 129.377C22.7528 129.429 25.8733 129.377 28.9939 129.377H39.3382C39.4959 129.377 39.6472 129.315 39.7588 129.204C39.8703 129.093 39.933 128.942 39.933 128.785C39.933 128.628 39.8703 128.478 39.7588 128.367C39.6472 128.256 39.4959 128.193 39.3382 128.193H39.3468Z",
    fill: "#1BC457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.583 101.504V120.378C130.705 122.11 130.17 123.824 129.083 125.182C128.434 125.897 127.633 126.46 126.739 126.831C125.844 127.201 124.879 127.371 123.911 127.327H103.955C103.798 127.327 103.646 127.389 103.535 127.5C103.423 127.611 103.361 127.762 103.361 127.919C103.361 128.076 103.423 128.226 103.535 128.337C103.646 128.448 103.798 128.511 103.955 128.511H123.67C125.337 128.594 126.992 128.179 128.42 127.318C129.446 126.638 130.288 125.717 130.873 124.637C131.457 123.557 131.767 122.351 131.773 121.124C131.833 118.019 131.773 114.913 131.773 111.808V101.513C131.773 101.356 131.71 101.206 131.599 101.095C131.487 100.983 131.336 100.921 131.178 100.921C131.02 100.921 130.869 100.983 130.758 101.095C130.646 101.206 130.583 101.356 130.583 101.513V101.504Z",
    fill: "#1BC457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3 11.0068H123.265C125.006 10.8885 126.729 11.4242 128.092 12.5081C128.812 13.1533 129.38 13.9499 129.752 14.8402C130.125 15.7304 130.294 16.6921 130.247 17.6554V37.541C130.247 37.698 130.31 37.8486 130.421 37.9596C130.533 38.0706 130.684 38.133 130.842 38.133C131 38.133 131.151 38.0706 131.263 37.9596C131.374 37.8486 131.437 37.698 131.437 37.541V17.8956C131.521 16.2335 131.103 14.5844 130.239 13.1601C129.555 12.1391 128.63 11.3008 127.545 10.7189C126.46 10.137 125.248 9.82933 124.015 9.82293C120.894 9.77145 117.774 9.82293 114.653 9.82293H104.309C104.151 9.82293 104 9.88528 103.888 9.99629C103.777 10.1073 103.714 10.2579 103.714 10.4149C103.714 10.5719 103.777 10.7224 103.888 10.8334C104 10.9444 104.151 11.0068 104.309 11.0068H104.3Z",
    fill: "#1BC457"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2820_24535",
    x: 0.0666685,
    y: 0.266667,
    width: 143.867,
    height: 162.067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.866666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2820_24535"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2820_24535",
    result: "effect2_dropShadow_2820_24535"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.03333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2820_24535",
    result: "effect3_dropShadow_2820_24535"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.46667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2820_24535",
    result: "effect4_dropShadow_2820_24535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2820_24535",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.7c2ac86edd04c494edffec206caf8d97.svg";
export { ForwardRef as ReactComponent };